import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { Button } from '../../../shared/components/Button';
import TemplateLayoutHeader from '../../../shared/layout/TemplateLayout/components/TemplateLayoutHeader';
import { route } from '../../../shared/utils';
const EmailListHeader = () => {
    return (_jsx(TemplateLayoutHeader, { children: _jsxs("div", { className: "px-6 py-3 flex items-center justify-between", children: [_jsx("div", { className: "text-default font-semibold", children: "Emails" }), _jsx(NavLink, { to: route('/templates/emails/new'), children: _jsx(Button, { children: "New template" }) })] }) }));
};
export default EmailListHeader;
